<!-- eslint-disable vue/no-unused-components -->
<template>
<main>
        <section>
            <div class="container col-xxl-8 px-4 pt-5 mb-5 pb-5 ">
                <div class="row flex-lg-row-reverse align-items-center g-5 py-5">
                    <div class="col-10 col-sm-8 col-lg-7">
                        <img src="../assets/hero2.png" class="hero-img d-block mx-lg-auto img-fluid" alt="Hero Image"
                            loading="lazy">
                    </div>
                    <div class="col-lg-5 mt-5">
                        <h1 class="hero-text display-5 fw-bold lh-1 mb-3"> Have a broken
                                Gadget ?</h1>
                        <h5 class="hero-subtext display-5 fw-bold lh-1 mb-3"> Have a broken Gadget ?</h5>

                        <p class="lead">Lorem ipsum dolor sit amet, consetetur sadipscing
                            elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed
                            diam voluptua. At vero eos et </p> <br>

                        <div class="d-grid gap-2 d-md-flex justify-content-md-start">
                            <router-link to="/signup"><button type="button" class="button btn btn-dark btn-lg px-4 me-md-2">
                                <p class="mt-3">Get Started</p>
                            </button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container-fluid brands pb-5">
                <div class="text-center ">
                    <div class="row">
                        <div class=" col-lg-2 col-md-3 col-sm-4 col-xs-2 pt-5">
                            <img alt="partner" src="../assets/Group7.png">
                        </div>

                        <div class=" col-lg-2 col-md-3 col-sm-4 col-xs-2 pt-5">
                            <img alt="partner" src="../assets/Group8.png">
                        </div>

                        <div class=" col-lg-2 col-md-3 col-sm-4 col-xs-2 pt-5">
                            <img alt="partner" src="../assets/Group9.png">
                        </div>

                        <div class=" col-lg-2 col-md-3 col-sm-4 pt-5">
                            <img alt="partner" src="../assets/Group13.png">
                        </div>

                        <div class=" col-lg-2 col-md-3 col-sm-4 pt-5">
                            <img alt="partner" src="../assets/Group14.png">
                        </div>

                        <div class=" col-lg-2 col-md-3 col-sm-4 pt-5">
                            <img alt="partner" src="../assets/Group18.png">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="about-section mt-5 py-5 container">

            <div class="row ">
                <div class="col-lg-6">
                    <img src="../assets/about.png" class="about-img d-block img-fluid" alt="About Image">
                </div>

                <div class="col-lg-6 mt-5 pl-5">
                    <h5 class="hero-subtext display-5 fw-bold lh-1 mb-3"> Who are we ?</h5>
                    <h1 class="hero-text display-5 fw-bold lh-1 mb-3"> About Fixit</h1>


                    <p class="lead">Lorem ipsum dolor sit amet, consetetur sadipscing
                        elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed
                        diam voluptua. At vero eos et </p> <br>

                    <div class="d-grid gap-2 d-md-flex justify-content-md-start">
                            <router-link to="/signup"><button type="button" class="button btn btn-dark btn-lg px-4 me-md-2">
                                <p class="mt-3">Get Started</p>
                            </button>
                            </router-link>
                        </div>
                </div>
            </div>

        </section>

        <section class="info container-fluid pb-5">
            <div class=" container mt-5 py-5">
                <div class="row flex-lg-row-reverse mt-5">
                    <div class="col-lg-6">
                        <img src="../assets/info.png" class="about-img d-block mx-auto img-fluid mt-lg-5 pt-lg-5"
                            alt="About Image">
                    </div>

                    <div class="col-lg-6 mt-5 pl-5">
                        <div class="row pr-lg-5">
                            <div class="col-2">
                                <img alt="num1" src="../assets/1.png">
                                <div class="line mt-3">
                                </div>
                            </div>
                            <div class="col-10">
                                <h5 class=" mt-4">Create Your Account</h5>
                                <p>Lorem ipsum dolor sit amet, consetetur sadipscing
                                    elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
                                    erat, sed
                                    diam voluptua. At vero eos et </p><br>
                            </div>


                            <div class="col-2">
                                <img alt="num2" src="../assets/2.png">
                                <div class="line mt-3">
                                </div>
                            </div>
                            <div class="col-10">
                                <h5 class=" mt-4">Lodge Your Complaint</h5>
                                <p>Lorem ipsum dolor sit amet, consetetur sadipscing
                                    elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
                                    erat, sed
                                    diam voluptua. At vero eos et </p><br>
                            </div>


                            <div class="col-2">
                                <img alt="num3" src="../assets/3.png">
                            </div>
                            <div class="col-10">
                                <h5 class=" mt-4">Get Your Device Fixed</h5>
                                <p>Lorem ipsum dolor sit amet, consetetur sadipscing
                                    elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
                                    erat, sed
                                    diam voluptua. At vero eos et </p>
                            </div>
                        </div>

                        <div class="d-grid gap-2 d-md-flex justify-content-md-start mt-5">
                            <router-link to="/signup"><button type="button" class="button btn btn-dark btn-lg px-4 me-md-2">
                                <p class="mt-3">Get Started</p>
                            </button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

        </section>

        <section class="py-5">

            <div class="col-lg-10 offset-lg-1 pt-5 pb-5  ">
            <h1 class="text-center"><b>Happy Customers</b></h1>
                <div id="client-testimonial-carousel" class="carousel slide" data-ride="carousel" style="">
                    <div name="comment" class="carousel-inner" role="listbox">
                        <div class="carousel-item active text-center p-4">
                            <blockquote class="blockquote text-center">
                                <p class="quote mb-4"><i class="fa fa-quote-left"></i>  Lorem ipsum dolor sit amet,
                                    consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
                                    dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo
                                    dolores et ea rebum.  <i class="fa fa-quote-right"></i>
                                </p>
                                 <span class="blockquote-footer mb-2">Albert Einstein</span><img src="https://images-na.ssl-images-amazon.com/images/I/51FPLPtf2%2BL._AC_.jpg" alt="user" class="img" />
                                 
                                
                            </blockquote>
                        </div>
                        
                    </div>
                    <ol class="carousel-indicators">
                        <li data-target="#client-testimonial-carousel" data-slide-to="0" class="active"></li>
                        <li data-target="#client-testimonial-carousel" data-slide-to="1"></li>
                        <li data-target="#client-testimonial-carousel" data-slide-to="2"></li>
                    </ol>
                </div>
            </div>

        </section>

        <section class="info container-fluid p-5">
<div class="container">
<div class="row py-5">
<div class="col-lg-4">
<h5 class="hero-subtext display-5 fw-bold lh-1 mb-3">Articles</h5>
<h1 class="">Lorem Ipsum Dolor<br> Sit Amet?</h1><br>
<button type="button" class="button btn btn-dark btn-lg px-4 mb-5 me-md-2">
                                <p class="mt-3">Go To Blog</p>
                            </button>
</div>

<div class="col-lg-8 row">
<div class="col-lg-6">

<img alt="blog" class="blog-image" src="../assets/blog1.png">
<h4 class="my-3">Lorem Ipsum Dolor Sit Amet</h4>
<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec vel pretium odio. Phasellus elementum convallis convallis. Proin sit amet euismod lectus. 
</p>

<a href="#">Read More</a><br>
<hr id="hr"/>

</div>
<div class="col-lg-6">

<img alt="blog" class="blog-image" src="../assets/blog2.png">
<h4 class="my-3">Lorem Ipsum Dolor Sit Amet</h4>
<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec vel pretium odio. Phasellus elementum convallis convallis. Proin sit amet euismod lectus. 
</p>

<a href="#">Read More</a><br>
<hr id="hr"/>

</div>
</div>
</div>
</div>

        </section>

        <section class="container-fluid py-5">

        <div class="container py-5">
        <h1 class="text-center">Subscribe To Our Mailing List ?</h1>

        <form class="py-4">
        <input class=" mail form-control shadow mx-auto px-4" type="text" placeholder="Email Address" />

        <button type="button" class="button btn btn-dark btn-lg px-4 d-block mx-auto my-5 me-md-2">
                                <p class="mt-3">Subscribe Now</p>
                            </button>
        </form>
        </div>
        
        </section>

        <footer class="page-footer py-5 ">

    <!-- Footer Links -->

    <div class="container text-md-left pt-5">

        <!-- Grid row -->
        <div class="row">

            <!-- Grid column -->
            <div class="col-md-4 pr-5 mt-md-0 mt-3">

                <!-- Content -->
                <!-- <h5 class="text-uppercase">Footer Content</h5> -->

                <a href="/">Logo</a>

                <p class="pt-4">Hub One, 10 Hughes Ave, Alagomeji-Yaba 100001, Lagos.</p>

            </div>
            <!-- Grid column -->

            <hr class="clearfix w-100 d-md-none pb-3">

            <!-- Grid column -->
            <div class="col-md-3 mb-md-0 mb-3">

                <!-- Links -->
                <h5 class="text-uppercase">About</h5>

                <ul class="list-unstyled">
                    <li>
                        <a href="#!">About Us</a>
                    </li>
                    <li>
                        <a href="#!">Business</a>
                    </li>
                    <li>
                        <a href="#!">Careers</a>
                    </li>

                </ul>

            </div>
            <!-- Grid column -->

            <!-- Grid column -->
            <div class="col-md-3 mb-md-0 mb-3">

                <!-- Links -->
                <h5 class="text-uppercase">Contact</h5>

                <ul class="list-unstyled">
                    <li>
                        <a href="#!">support@fixit.ng</a>
                    </li>
                    <li>
                        <a href="#!">09070750710</a>
                    </li>
                    <li>
                        <a href="#!">09014113228</a>
                    </li>
                    <li>
                        <a href="#!">07088885982</a>
                    </li>
                </ul>

            </div>
            <!-- Grid column -->

            <!-- Grid column -->
            <div class="col-md-2 mb-md-0 mb-3">

                <!-- Links -->
                <h5 class="text-uppercase">Socials</h5><br>

                <i><img src="../assets/instagram.png" alt="instagram"></i>
                &nbsp;&nbsp;

                <i> <img src="../assets/twitter.png" alt="twitter"></i>&nbsp;&nbsp;&nbsp;

                <i> <img src="../assets/facebook.png" alt="facebook"></i>

            </div>
            <!-- Grid column -->

        </div>
        <!-- Grid row -->

    </div>
    <!-- Footer Links -->
</footer>
<!-- Footer -->

<!-- Copyright -->
<div class="footer-copyright text-center py-3">© Copyright 2020 :
    <a href="#">Fixit</a>
</div>
<!-- Copyright -->

    </main>
</template>

<script>
//import firebase from 'firebase'

export default {

    data(){
        return{
            
        }
    }
}

    
    
      
</script>
<style>
h4{
display: block
}
</style>
<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300&display=swap");

#app {
  font-family: "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #ffffff;
  width: 100%;
  
  color: #000000;
  
}

footer{
color: rgb(223, 223, 223);
background-color: #141618;
}

.blog-image{
width: 100%;
}

.mail{
    width: 70%;
}
.form-control{
    border-radius: 50px;
    height: 60px;
    border: none;
    background-color: rgb(248, 248, 248);
}

#hr{
    width: 70px;
    float: left;
    border-width: 5px ;
}

.footer-copyright{
background-color: black;
color: rgb(235, 233, 233);
}
.img{
    width: 3rem;
    height: auto;
}

span{
    display: inline;
}

blockquote{
    padding: 0 15%;
}
.quote{
    color: black;
}

html {
  scroll-behavior: smooth;
}

button p{
    color: white;
}

main{
    margin-top: 4%;
}

h1 {
            font-size: 35px;
        }

        p {
            font-size: 18px !important;
        }

        router-link.button {
            width: 40%;
        }

        .hero-subtext {
            color: gray;
        }

        .brands {
            background-color: #f6f6f6;
            
        }

        .about-img {
        height: auto;
            width: 80%;
        }

        .info {
            background-color: #f6f6f6;
        }

        .hero-img {
            width: 80%;
            height: auto;
        }

        .line {
            border-left: 3px solid rgb(0, 0, 0);
            height: 120px;
            margin-left: 30px;
        }

        .container {
            min-width: 80% !important;
        }
</style>